import { render, staticRenderFns } from "./BookingVehicleModal.vue?vue&type=template&id=fb2d0af8"
import script from "./BookingVehicleModal.vue?vue&type=script&lang=js"
export * from "./BookingVehicleModal.vue?vue&type=script&lang=js"
import style0 from "./BookingVehicleModal.vue?vue&type=style&index=0&id=fb2d0af8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports